import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { unescapeHTML, titleize } from 'underscore.string';
import { NavLink } from 'react-router-dom';
import { Menu } from '@headlessui/react';
import CargomaticLogo from 'img/cargomatic-logo-dark.png';
import SessionStore from 'stores/SessionStore';
import classNames from 'classnames';
import Navbar from 'components/v2/navs/Navbar';
import UserActionCreators from 'actions/UserActionCreators';
import { Avatar } from 'components/modules/user/Avatar';
import LanguageSelector from 'components/site/language-selector';
import DropdownMenu from 'components/v2/dropdowns/DropdownMenu';

const activeStyle = {
  fontWeight: 'bold',
  color: 'white',
};

function logout() {
  UserActionCreators.logout();
}

export default function WarehouseNavigation() {
  const { t } = useTranslation();

  function renderMobileNav(onClose) {
    return [
      <NavLink
        className="nav-item"
        to="/warehouse/user/profile"
        onClick={onClose}
        key="mobile-profile"
      >
        <span>{titleize(t('PROFILE', { count: 1 }))}</span>
      </NavLink>,
      <a href="#" className="nav-item" onClick={logout} key="mobile-signout">
        {t('SIGN_OUT')}
      </a>,
    ];
  }
  function renderRightNav() {
    const name = SessionStore.getUser().name;
    const userId = SessionStore.getUser()._id;
    let profileButton = null;

    profileButton = (
      <div
        key="profile-button"
        data-testid="profile-button"
        title={unescapeHTML(name)}
        className="flex text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-gray-800 focus:ring-white"
        aria-haspopup="true"
      >
        <Avatar
          key={userId}
          userId={userId}
          altName="Logo"
          className="w-8 h-8 rounded-full"
        />
      </div>
    );

    return [
      <div
        key="language-selector"
        data-testid="warhouse-nav-language-selector"
        className={classNames(
          'flex items-center justify-center nav-item mr-2',
          { hidden: LANGUAGE_SELECTION_DISABLED },
        )}
      >
        <LanguageSelector />
      </div>,
      <DropdownMenu
        title="WarehouseUser Center"
        button={profileButton}
        isDark
        key="main-dropdown"
      >
        <Menu.Item key="profile">
          <NavLink
            activeClassName="active-light"
            className="nav-item"
            to="/warehouse/user/profile"
          >
            <span>{titleize(t('PROFILE', { count: 1 }))}</span>
          </NavLink>
        </Menu.Item>
        <Menu.Item key="sign-out">
          <a href="#" className="nav-item" onClick={logout}>
            {t('SIGN_OUT')}
          </a>
        </Menu.Item>
      </DropdownMenu>,
    ];
  }
  const brandLogo = (
    <NavLink to="/" key="brand-logo">
      <img alt="Cargomatic" src={CargomaticLogo} style={{ height: 25 }} />
    </NavLink>
  );

  return (
    <Navbar
      logo={brandLogo}
      renderRightNav={renderRightNav}
      renderMobileNav={renderMobileNav}
    />
  );
}
